export default {
  computed: {
    $typeAheadPlacesData() {
      // console.log(this.$store.getters["places/googleSearchPlaces"]);
      // console.log(this.$store.getters["places/userPlaces"]);
      // console.log([
      //   ...this.$store.getters["places/userPlaces"],
      //   ...this.$store.getters["places/googleSearchPlaces"],
      // ]);
      return [
        ...this.$store.getters["places/userPlaces"],
        ...this.$store.getters["places/googleSearchPlaces"]
      ];
    }
  }
};
